import axiosReadInstance from '../../request/axiosReadInstance'

const API_URL = process.env.REACT_APP_API_URL

export const fetchContactForm = async () => {
    return axiosReadInstance.get(`${API_URL}/api/contact-form?populate=*`)
}
